// React
import { useRef, useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import PropTypes from 'prop-types'

// Libraries

// Components

// Shared

export const PortalWrapper = ({ open = false, children, containerRef }) => {
  const innerRef = useRef(null)
  const [portalContainer, setPortalContainer] = useState(null)

  useEffect(() => {
    if (!containerRef) {
      const div = document.createElement('div')
      document.body.appendChild(div)
      innerRef.current = div

      setPortalContainer(div)

      return () => {
        if (innerRef.current) {
          document.body.removeChild(innerRef.current)
        }
      }
    } else {
      setPortalContainer(containerRef.current)
    }
  }, [containerRef])

  if (!open || !portalContainer) {
    return null
  }

  return createPortal(children, portalContainer)
}

PortalWrapper.displayName = 'PortalWrapper'

PortalWrapper.propTypes = {
  children: PropTypes.node,
  open: PropTypes.bool,
  containerRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) })
}

export default PortalWrapper
